$(function() {

	/**
	 * Manually distribute lead.
	 */
	if( $('#modal-lead-distribute').length ) {
		$('#form-lead-distribute .btn-lead-distribute').each(function(){
			$(this).click(function(e){
				e.preventDefault();
				
				var form = $('#form-lead-distribute');
				var action = form.attr('action');
				var method = form.attr('method');

				var partner_id = $(this).data('partner-id');
				$('#form-lead-distribute #partner_id').val(partner_id);

				var distribution_type = $(this).data('distribution_type');
				$('#form-lead-distribute #distribution_type').val(distribution_type);

				var distribution_action = $(this).closest('td').find('.radio-inline input:radio:checked').val();
				$('#form-lead-distribute #distribution_action').val(distribution_action);

				var data = form.serialize();
				$.ajax({
			        type: method,
			        url: action,
			        data: data,
			        async: true
			    })
			    .done(function(r) {
		        	console.log(r);
					if ( typeof r.status !== 'undefined') {
						switch(r.status) {
							case 'sold' :
								$('.distribution-success').hide('slow');
								$('.distribution-success').html('Lead sent to ' + r.buyer + ' for $' + r.price).show('slow');
								$('.distribution-error').hide();
							break;
							case 'no_buyer' :
								$('.distribution-success').hide();
								$('.distribution-error').hide('slow');
								var msg = 'Lead was not sold due to an error.<br>';
								if ( typeof r.errors !== 'undefined' ) {
									if ( Object.prototype.toString.call( r.errors ) === '[object Array]' ) {
										msg += r.errors.join('<br>');
									} else {
										msg += r.errors;
									}
								}
								$('.distribution-error').html(msg).show('slow');
							break;
						}
					}
		        })
		        .fail(function(xhr) {
		        	$('.distribution-error').hide('slow');
		        	var msg = 'Lead was not sold due to the following error(s):<br>';
					if (xhr.status == 422) {						
						msg += '<ul>';
						for (var i in xhr.responseJSON) {
							for (var j in xhr.responseJSON[i])
								msg += '<li>' + xhr.responseJSON[i][j] + '</li>';
						}
						msg += '</ul>';
					}
					else {
						msg += xhr.status + ': ' + xhr.statusText;
					}
					$('.distribution-error').html(msg).show('slow');
		        });
			});
		});
	}

	/**
	 * Lead & Sales search filters.
	 */
	if( $('#modal-search-filters').length ) {
		$('#form-search-filter-btn').click(function(e){
			e.preventDefault();
			if ($('#form-search-filters #date_filter').val()=='custom'
						&&
						( $('#form-search-filters #start_date').val().length == 0
							||
							$('#form-search-filters #end_date').val().length == 0
						)
				) {
				$('#form-search-filters .errors').html('Please select a start and end date.');
			$('#form-search-filters .errors').show('slow');
			} else {
				$('#form-search-filters .errors').html('');
				$('#form-search-filters .errors').hide();
				$('#form-search-filters').submit();
			}
		});

		$('.btn-date-group button').click(function(e){
			e.preventDefault();
			var date_filter = $(this).data('value');
			$('.btn-date-group button').removeClass('active');
			$('#form-search-filters #date_filter').val(date_filter);
			$(this).addClass('active');
			if(date_filter=='custom') {
				$('.date_filter_custom').show();
			} else {
				$('.date_filter_custom').hide();
			}
		});
	}
});

jQuery.validator.addMethod(
    "multiemail",
     function(value, element) {
         if (this.optional(element)) // return true on optional element 
             return true;
         var emails = value.split(/[;,]+/); // split element by , and ;
         valid = true;
         for (var i in emails) {
             value = emails[i];
             valid = valid &&
                     jQuery.validator.methods.email.call(this, $.trim(value), element);
         }
         return valid;
     },

    jQuery.validator.messages.email
);